import {WalletContext} from '#/contexts/wallet-provider';
import {baseKeysUseQuery} from '#/hooks/query/base/base-keys-use-query';
import {userProfileRequests} from '#/repository/fetch-user-profile';
import {useQuery} from '@tanstack/react-query';
import {useContext} from 'react';
import {useAccount} from 'wagmi';

export const useUserProfile = (params: {account: string | undefined; enabled?: boolean}) => {
  const {account, enabled = true} = params;
  const {address: currentAccount} = useAccount();

  return useQuery({
    queryKey: [baseKeysUseQuery.useUserProfile, account],
    queryFn: () => userProfileRequests.get({account: account!, skipCache: account === currentAccount}),
    enabled: enabled && !!account && !!currentAccount,
  });
};

export const useUserProfilePrivate = (params?: {enabled?: boolean; refetchOnMount?: boolean | 'always'}) => {
  const {enabled = true, refetchOnMount = 'always'} = params ?? {};
  const {
    accountResult: {address: currentAccount},
    walletClient,
    web3AuthSignatureResult: {data: web3AuthIdTokenGroup},
  } = useContext(WalletContext);

  return useQuery({
    queryKey: [baseKeysUseQuery.useUserProfilePrivate, currentAccount],
    queryFn: () => userProfileRequests.getPrivate({account: currentAccount!}, web3AuthIdTokenGroup!),
    enabled: enabled && !!currentAccount && !!walletClient && !!web3AuthIdTokenGroup,
    retry: false,
    retryOnMount: false,
    refetchOnMount,
    refetchOnWindowFocus: false,
  });
};
